import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";
import type { ProvidersList } from "@reactive-resume/dto";

const getProviders = async (page?: number) => {
  const response = await axios.get<ProvidersList>("/provider", {
    params: { page },
    paramsSerializer: (params) => qs.stringify(params),
  });
  console.log(response.data);
  return response.data;
};

export const useProviders = (page?: number) => {
  const {
    data: providers,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["providers", page],
    queryFn: () => getProviders(page),
  });

  return { providers, loading, error };
};

/** Provider renvoye par la liste complete (selects de l'admin). */
export type ProviderSelectItem = {
  id: string;
  name: string;
  isActive: boolean;
  mode: string | null;
};

const getAllProviders = async () => {
  const response = await axios.get<ProviderSelectItem[]>("/provider/all");
  return response.data;
};

/**
 * Liste COMPLETE des providers (non paginee), pour les listes deroulantes de
 * l'admin.
 *
 * ⚠️ Ne pas utiliser `useProviders()` dans un select : le serveur pagine avec
 * une limite par defaut de 5 (`/provider?limit`), ce qui ne renvoyait que 5
 * agregateurs sur 7 et rendait kkiapay / cinetpay inaffectables a un pays.
 */
export const useAllProviders = () => {
  const {
    data: providers,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["providers", "all"],
    queryFn: getAllProviders,
  });

  return { providers, loading, error };
};

export const useDeleteProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => axios.delete(`/provider/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
